import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { Container, Grid } from "@material-ui/core";
import { HeaderHLPure, ButtonHLPure } from "../../pures";
import { AddPublicityDataView, AddPublicityCatalogView } from "../";
import { useHistory } from 'react-router-dom'
import StepperPure from "../../pures/stepper/stepper.pure";

const AddPublicityView = (props) => {
  const { t } = useTranslation();
  const { steps, sendData, isValidInfoPage } = props
  const history = useHistory()

  const [value, setValue] = useState(0);

  const onNextClick = () => {
    setValue(value + 1)
  }

  return (
    <Container className="view-container">
      <Grid container spacing={3}>
        <Grid item xs={12}>
          <HeaderHLPure title={t("publicityView.addNewPublicity")} />
        </Grid>

        <Grid item xs={12}>
          <Container maxWidth={"md"}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <StepperPure
                  value={value}
                  items={steps}
                />
              </Grid>

              <Grid item xs={12}>
                {value === 0 && (
                  <AddPublicityDataView {...props} />
                )}
                {value === 1 && (
                  <AddPublicityCatalogView {...props} />
                )}
              </Grid>

              <Grid item xs={12} className="button-actions">
                <ButtonHLPure
                  nameBtn={value === 1 ? t('button.goBack') : t('button.cancel')}
                  outlined colorScheme="error"
                  onClick={() => {
                    if (value === 1) {
                      setValue(0)
                    } else {
                      history.push('/publicity')
                    }
                  }}
                />

                <ButtonHLPure
                  nameBtn={value === 0 ? t('button.next') : t('button.save')}
                  primary outlined={value === 1}
                  onClick={() => {
                    const page = value + 1
                    const validPage = isValidInfoPage(page)
                    if (validPage) {
                      value === 1 ? sendData() : onNextClick()
                    }
                  }}
                />
              </Grid>
            </Grid>
          </Container>
        </Grid>
      </Grid>
    </Container>
  );
}

export { AddPublicityView as default };